<template>
  <div>
    <div class="px-6">
      <v-container class="px-0">
        <div
          class="d-flex justify-space-between align-center flex-lg-row flex-row"
          :class="[
            $vuetify.breakpoint.lgAndDown ? 'mt-3 mb-3' : 'mt-7 mb-7',
            $vuetify.breakpoint.xsAndDown ? 'flex-column' : 'flex-row',
          ]"
        >
          <div
            class="w-100 d-flex align-center justify-space-between top-title"
          >
            <h1 class="font-weight-800">
              {{ $t("heading.navbar.tab.myHosting") }}
            </h1>
          </div>
        </div>
      </v-container>
    </div>

    <v-divider
      :class="$vuetify.breakpoint.lgAndDown ? 'mb-3' : 'mb-10'"
    ></v-divider>

    <div class="px-6">
      <v-container v-if="selectedService" class="px-0">
        <v-row
          align="stretch"
          class="mx-0 flex-lg-row flex-column"
          no-gutters
          :class="[$vuetify.breakpoint.mobile ? 'mobile-container' : '']"
        >
          <hosting-pages-sidebar
            v-if="!serviceLoading"
            :services="services"
            :activeService="selectedService"
            @update:activeService="changeService"
          />
          <v-col
            cols="12"
            lg="10"
            :class="[$vuetify.breakpoint.lgAndDown ? `` : 'pl-12']"
          >
            <router-view
              v-if="!serviceLoading"
              :service="selectedService"
              @pass-instance="passNewInstanceData"
            />
          </v-col>
        </v-row>
      </v-container>
      <NoAvailableHostingView
        v-else-if="suspendedService"
        :suspendedService="suspendedService"
      />
    </div>
  </div>
</template>

<script>
import Api from "../../apis/Api";

import NoAvailableHostingView from "../../components/NoAvailableHostingView.vue";
import HostingPagesSidebar from "../../components/HostingPagesSidebar.vue";
import EmailDomainRecordsMixin from "../../mixins/EmailDomainRecordsMixin";

export default {
  components: {
    HostingPagesSidebar,
    NoAvailableHostingView,
  },
  mixins: [EmailDomainRecordsMixin],
  data() {
    return {
      serverAccountsLoading: true,
      serverAccounts: [],
      serverAccount: null,
      hostingAccountId: null,
      suspendedService: null,
      serviceLoading: true,
      services: [],
      selectedService: null,
      selectedServiceId: null,
    };
  },
  methods: {
    checkTitleAndRedirect() {
      const currentRoutePath = this.$route.path;
      if (currentRoutePath.includes("/hosting/domains")) {
        if (
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_domains"
          )
        ) {
          this.redirectToSummary();
        }
      } else if (currentRoutePath.includes("/hosting/ftp")) {
        if (
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_ftp"
          )
        ) {
          this.redirectToSummary();
        }
      } else if (currentRoutePath.includes("/hosting/sftp")) {
        if (
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_sftp"
          )
        ) {
          this.redirectToSummary();
        }
      } else if (currentRoutePath.includes("/hosting/databases")) {
        if (
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_mysql"
          ) &&
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.phpmyadmin_sso"
          )
        ) {
          this.redirectToSummary();
        }
      } else if (currentRoutePath.includes("/hosting/cron")) {
        if (
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_cron"
          )
        ) {
          this.redirectToSummary();
        }
      } else if (currentRoutePath.includes("/hosting/file-manager")) {
        if (
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_file_manager"
          )
        ) {
          this.redirectToSummary();
        }
      } else if (currentRoutePath.includes("/hosting/dns")) {
        if (
          !this.selectedService.dns_server_enabled ||
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_dns"
          ) ||
          !this.selectedService.plan_settings.dns_management_enabled
        ) {
          this.redirectToSummary();
        }
      } else if (currentRoutePath.includes("/hosting/email-addresses")) {
        if (
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_email" || !this.selectedService.email_server_enabled
          )
        ) {
          this.redirectToSummary();
        }
      } else if (currentRoutePath.includes("/hosting/email-forwarders")) {
        if (
          !this.selectedService.getUserPrivileges(
            this.selectedService.privileges,
            "hosting.manage_email" || !this.selectedService.email_server_enabled
          )
        ) {
          this.redirectToSummary();
        }
      }
    },
    redirectToSummary() {
      this.$router.push("/hosting/summary");
    },
    passNewInstanceData(instance) {
      this.hostingAccountId = instance.hostingId;
    },
    changeService: function (item) {
      this.selectedService = item;
      this.setPlanIdInSession(this.selectedService.id);
      this.checkTitleAndRedirect();
    },
    setPlanIdInSession: function (serviceItemId) {
      sessionStorage.setItem("selectedPlanId", JSON.stringify(serviceItemId));
    },
    getPlanIdFromSession: function () {
      const storedPlanItem = sessionStorage.getItem("selectedPlanId");
      if (storedPlanItem) {
        this.selectedServiceId = JSON.parse(storedPlanItem);
      }
    },
    getServiceIdFromQuery: function () {
      if (!this.$route.query.id) {
        return false;
      }

      const id = this.$route.query.id;

      let query = Object.assign({}, this.$route.query);
      delete query.id;
      this.$router.replace({ query });
      return id;
    },
    checkEmailDomains(service) {
      Api.cached(0)
        .get(`/services/${service.id}/email/domains`)
        .then((response) => {
          service.showEmailRecordConfiguration =
            response.data.meta.is_email_dns_records_showed;
          const emailDomains = response.data.data.map((domain) => {
            return this.initEmailDomainInfo(domain);
          });
          this.checkAllDomains(emailDomains).then((result) => {
            service.isEmailRecordsConfigured = result;
          });
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem("selectedPlanId");
    next();
  },
  mounted() {
    if (this.$route.params && this.$route.params.instance) {
      this.selectedServiceId = this.$route.params.instance.service_id;
    } else {
      this.getPlanIdFromSession();
    }
    if (!this.$store.state.home.user.has_hosting_access) {
      this.$router.push({ name: "Instances" });
      return;
    }

    const serviceId = this.selectedServiceId
      ? this.selectedServiceId
      : this.getServiceIdFromQuery();

    Api.get("/services")
      .then((response) => {
        const services = response.data.data.map((service) => {
          service.server_accounts = service.server_accounts.map(
            (serverAccount) => {
              if (serverAccount.details && serverAccount.details.homedir) {
                serverAccount.homedir = `${serverAccount.details.homedir}/`;
              }

              if (
                serverAccount.details &&
                serverAccount.details.mysql_db_prefix
              ) {
                serverAccount.mysql_db_prefix =
                  serverAccount.details.mysql_db_prefix;
              }
              if (serverAccount.main_domain_nameservers) {
                serverAccount.nameservers =
                  serverAccount.main_domain_nameservers || [];
              }

              if (serverAccount.details && serverAccount.details.ip_address) {
                serverAccount.ip_address =
                  serverAccount.details.ip_address || null;
              }
              return serverAccount;
            }
          );
          return service;
        });

        for (const service of services) {
          if (service.status == "suspended" || service.status == 'cancelled') {
            this.suspendedService = service;
            continue;
          }
          if (!service.server_accounts.length) {
            continue;
          }
          if (service.status !== "active") {
            continue;
          }
          let hasAnyHostingPrivilege = false;
          for (const priv of service.privileges) {
            if (priv.startsWith("hosting.")) {
              hasAnyHostingPrivilege = true;
              break;
            }
          }
          if (!hasAnyHostingPrivilege) {
            continue;
          }

          service.name = `${service.plan_name} - ${service.domain}`;

          service.isEmailRecordsConfigured = true;
          service.showEmailRecordConfiguration = false;

          service.getUserPrivileges = (privileges, permission) => {
            if (privileges && privileges.length) {
              return privileges.indexOf(permission) > -1;
            } else {
              return true;
            }
          };

          this.services.push(service);
        }

        if (!this.services.length) {
          return;
        }
        if (!serviceId) {
          this.selectedService = this.services[0];
        } else {
          const foundPlan = services.find((service) => {
            return service.id == serviceId;
          });

          if (!foundPlan) {
            this.selectedService = this.services[0];
          } else {
            this.selectedService = foundPlan;
          }
        }
        this.serverAccounts = this.selectedService.server_accounts;
      })
      .catch((error) => {
        this.$store.dispatch("addAlert", {
          success: false,
          errorMessage: Api.getErrorMessage(error),
        });
      })
      .finally(() => {
        this.serviceLoading = false;
      });
  },
  watch: {
    selectedService(service) {
      if (!service) {
        return;
      }
      if (service.email_server_enabled) {
        service.isEmailRecordsConfigured = true;
        this.checkEmailDomains(service);
      }
    },
  },
};
</script>

<style src="./index.scss" lang="scss" scoped />
